export default __webpack_public_path__ + "static/media/Path3535.784f2579.svg";